import React from 'react';
import './TopHeader.css';
import myImage from '../../assets/myImage/ehsan.JPG';
import Typewriter from 'typewriter-effect';
import ParticleBackground from '../Paricles/ParticleBackground';

const TopHeader = () => {
    return (
        <section className='md:mt-12 mt-10'>
            <ParticleBackground />
            <div className='md:grid md:grid-cols-2 flex flex-col-reverse'>
                <div className='flex justify-center items-center md:mx-0 mx-5'>
                    <div>
                        <h1 className='text-5xl font-semibold'>Hello! I'm</h1>
                        <h1 className='text-5xl font-bold text-teal-500 mt-5'>
                            Md. Ehsanul Islam Khan
                        </h1>
                        <h3 className='text-xl font-semibold text-gray-600 mt-4'>
                            <Typewriter
                                options={{
                                    strings: ["Assistant Engineer (IT) at YOUNGONE Corporation", "Web App Developer", "Tech Lover"],
                                    autoStart: true,
                                    loop: true,
                                    delay: '40',
                                    deleteSpeed: '40'
                                }}
                            />
                        </h3>
                        <p className='text-sm text-gray-600 mt-5 mr-5'>I am a self-motivated, highly passionate and hardworking person. I always try to implement my educational and professional skills for the success of my organization.
                        </p>
                        {/* <p className='text-sm text-gray-600 mt-5 mr-5'>I am a self-motivated, highly passionate and hardworking person. I am looking for an opportunity to
                            work in an organization where ethics & integrity are highly valued and at the same time I can
                            enhance my educational and professional skills by contributing to the success of the organization.
                        </p> */}
                        <a type='button' href="https://drive.google.com/file/d/1etYP3vlBaenp-oCT-4K11e3bcVieKL4S/view?usp=share_link"
                            target="_blank" rel="noopener noreferrer" className="text-white bg-gradient-to-br from-green-400 to-blue-600 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 mt-8">
                            Download Resume
                        </a>
                        <a type='button' href="https://drive.google.com/file/d/1sF8RMyLBCfaNwoqxUitHR9yMaXbg6xRs/view?usp=share_link"
                            target="_blank" rel="noopener noreferrer" className="text-white bg-gradient-to-br from-blue-600 to-green-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 mt-8">
                            Download CV
                        </a>
                    </div>
                </div>
                <div className='md:mb-0 mb-10 md:mx-0 mx-3'>
                    <img src={myImage} alt="myImage" className='rounded-md w-[85%] h-[100%]' />
                </div>
            </div>
        </section >
    );
};

export default TopHeader;